import { BodyText, HeaderText } from "@/components/ui";
import { Sparkles } from "lucide-react";

interface FollowUpOutreachBannerProps {
  carePlanOutreachEnabled?: boolean;
}

export const FollowUpOutreachBanner = ({
  carePlanOutreachEnabled,
}: FollowUpOutreachBannerProps) => {
  if (!carePlanOutreachEnabled) {
    return null;
  }

  return (
    <div className="rounded-lg bg-superclinical p-3 w-full mb-3">
      <div className="flex items-start gap-2">
        <Sparkles className="h-4 w-4 flex-shrink-0 stroke-ai mt-0.5" />
        <div className="flex flex-col gap-1">
          <HeaderText className="text-superclinical" size="sm">
            AI automatically sends a 2-day follow-up message based on above
            orders
          </HeaderText>
          <BodyText className="text-superclinical" size="sm">
            If you would like to send an additional message (i.e. GLP-1 3-week
            check-in), add below.
          </BodyText>
        </div>
      </div>
    </div>
  );
};
